<template>
  <div class="insurance-card-container">
    <div
      v-for="(packageObj, index) in packages"
      :key="index"
      v-if="index == 0 || expanded"
      style="display: flex; flex-direction: column; flex-grow: 1"
    >
      <CoverLimitReachedNotice
        :product-code="packageObj.code"
        :testator="testator"
        @updateInsurance="params => $emit('updateInsurance', params)"
        v-if="
          packageObj.price === 0 &&
          packageObj.code !== 'EC_D' &&
          packageObj.code !== 'TAC'
        "
      />
      <CoverLimitReachedNotice
        :product-code="packageObj.code"
        :testator="testator"
        @updateInsurance="params => $emit('updateInsurance', params)"
        v-else-if="showEducationCoverLimitReached(packages, packageObj)"
      />
      <CoverLimitReachedNotice
        :product-code="packageObj.code"
        :testator="testator"
        @updateInsurance="params => $emit('updateInsurance', params)"
        v-else-if="showCapitalGainsTaxLimitReached(packages, packageObj)"
      />

      <div v-if="packageObj.name" class="child-name-section">
        <h1>{{ packageObj.name }}</h1>
      </div>
      <div
        v-if="packageObj.titleLeft && packageObj.titleRight"
        class="product-with-titles-section"
      >
        <div style="flex: 1">
          <h1>{{ packageObj.titleLeft }}</h1>
        </div>
        <div style="flex: 1">
          <h1>{{ packageObj.titleRight }}</h1>
        </div>
      </div>
      <div class="insurance-card-container-section">
        <div>
          <div class="payout-title">
            <span>
              <span v-if="packageObj.leftPriceTitle">{{
                packageObj.leftPriceTitle
              }}</span>
              <span v-else>Payout</span>
              <br />
              <span
                class="payout-amt d-block d-lg-inline"
                :class="titleColor(packageObj)"
              >
                R {{ leftPriceForPackageObj(packageObj) | currency }}
                <span
                  v-if="
                    insuranceMaxReached(packageObj.price) ||
                    costDebtOrTax(packageObj)
                  "
                  class="title-icon"
                >
                  <v-img
                    :src="
                      require(`@/assets/${whitelabel.images.insuranceEducationInfoIcon}`)
                    "
                    class="info-icon mr-2"
                    contain
                  />
                </span>
              </span>
            </span>
          </div>
          <div class="insurance-text left">
            <span>{{ productText(packageObj) }}</span>
          </div>
        </div>
        <div>
          <div class="payout-title">
            <span>
              <span v-if="packageObj.rightPriceTitle">{{
                packageObj.rightPriceTitle
              }}</span>
              <span v-else>Premium</span>
              <br />
              <span
                v-if="packageObj.code === 'TAC'"
                class="payout-amt d-block d-lg-inline"
                :class="titleColor(packageObj)"
              >
                R {{ rightPriceForPackageObj(packageObj) | currency }}
              </span>
              <span
                v-else
                class="payout-amt d-block d-lg-inline"
                :class="titleColor(packageObj)"
                >R
                {{ (packageObj?.premium || 0).toFixed(0) | currency }} pm</span
              >
            </span>
          </div>
          <div class="insurance-text right">
            <span v-if="packageObj.descriptionRight">{{
              packageObj.descriptionRight
            }}</span>
            <span v-else>Amount you pay per month</span>
          </div>
        </div>
      </div>
      <div
        v-if="packageObj.extraBottomProduct"
        class="extra-bottom-product-section"
      >
        <div class="horizontal-break"></div>
        <div
          v-if="packageObj.extraBottomProduct"
          class="extra-product-with-titles-section"
        >
          <div style="flex: 1">
            <h1>{{ packageObj.extraBottomProduct.title }}</h1>
          </div>
        </div>
      </div>
      <div
        v-if="packageObj.extraBottomProduct"
        class="insurance-card-container-section"
      >
        <div>
          <div class="payout-title">
            <span>
              <span
                class="payout-amt d-block d-lg-inline"
                :class="titleColor(packageObj)"
              >
                R {{ packageObj.extraBottomProduct.price | currency }}
              </span>
            </span>
          </div>
          <div class="insurance-text left">
            <span>{{ packageObj.extraBottomProduct.description }}</span>
          </div>
        </div>
      </div>
      <!-- TODO: REMOVE THIS DIV -->
      <!-- <div
        v-if="packageObj.extraBottomProduct"
        style="height: 80px; background-color: pink"
      ></div> -->

      <div style="padding-top: 10px; padding-bottom: 10px">
        <ProductEstimateInfo
          v-if="infoMessage(packageObj)"
          :message="infoMessage(packageObj)"
        />
      </div>
      <div class="info-section-spacer"></div>

      <div
        v-if="!expanded && index == 0 && packages.length > 1"
        class="see-more-section"
        @click="expandClicked"
      >
        <div class="see-more-container">
          <p>View all children</p>
          <div class="chevron-container">
            <v-img
              aspect-ratio="0.95"
              :src="require('@/assets/shared/redesign/common/chevron_down.svg')"
            />
          </div>
        </div>
      </div>
      <div
        v-if="expanded && index == packages.length - 1 && packages.length > 1"
        class="see-less-section"
        @click="expandClicked"
      >
        <div class="see-less-container">
          <p>View less children</p>
          <div class="chevron-container">
            <v-img
              aspect-ratio="0.95"
              :src="require('@/assets/shared/redesign/common/chevron_down.svg')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProductEstimateInfo from './ProductEstimateInfo.vue';
  import CoverLimitReachedNotice from './CoverLimitReachedNotice.vue';
  import moment from 'moment';

  export default {
    name: 'InsuranceCardFooter',
    components: {
      ProductEstimateInfo,
      CoverLimitReachedNotice,
    },
    props: {
      packages: {
        required: false,
        type: Array,
      },
      testator: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        expanded: false,
      };
    },
    methods: {
      leftPriceForPackageObj(packageObj) {
        if (packageObj.code === 'TAC') {
          return packageObj.capitalGainsTaxAmount;
        }
        return packageObj.price;
      },
      rightPriceForPackageObj(packageObj) {
        if (packageObj.code === 'TAC') {
          return packageObj.taxAssistAmount;
        }
      },
      showEducationCoverLimitReached(packages, packageObj) {
        if (!packages) {
          return false;
        }
        if (packages[0].code !== 'EC_D') {
          return false;
        }
        const firstPackage = packageObj === packages[0];

        return (
          packages.filter(test => {
            return test.price === 0;
          }).length > 0 && firstPackage
        );
      },
      showCapitalGainsTaxLimitReached(packages, packageObj) {
        if (!packages) {
          return false;
        }
        if (packages[0].code !== 'TAC') {
          return false;
        }
        const firstPackage = packageObj === packages[0];
        if (!firstPackage) {
          return false;
        }
        return (
          packageObj.capitalGainsTaxAmount + packageObj.taxAssistAmount >=
          750000
        );
      },
      costDebtOrTax(pkg) {
        return (
          pkg.code == 'COC' ||
          pkg.code == 'DAC' ||
          pkg.code == 'CAC' ||
          pkg.code == 'TAC'
        );
      },
      productText(pkg) {
        if (pkg.evaluation !== undefined && pkg.evaluation !== 'qualified') {
          return 'Amount paid on your death';
        } else if (pkg.code === 'EC_D') {
          return `Amount paid annually for ${this.yearsUntilChildIs18(
            pkg.dateOfBirth
          )} years`;
        } else {
          return 'Amount paid on your death';
        }
      },
      infoMessage(pkg) {
        if (pkg.evaluation === 'failed_age_validation') {
          return `${pkg.name} doesn't meet the age requirement.`;
        } else {
          if (
            pkg.code == 'COC' ||
            pkg.code == 'DAC' ||
            pkg.code == 'CAC' ||
            pkg.code === 'TAC'
          ) {
            if (pkg.price) {
              return 'Estimated amount and not guaranteed';
            }
          }
        }
      },
      yearsUntilChildIs18(dateOfBirth) {
        const birthdayThisYear = moment(dateOfBirth).set(
          'year',
          moment().year()
        );
        const turning18Date = moment(moment(dateOfBirth)).add(18, 'years');
        const yearsUntil18 = turning18Date.diff(birthdayThisYear, 'years');
        if (yearsUntil18 > 12) {
          return 12;
        } else {
          return yearsUntil18;
        }
      },
      insuranceMaxReached(coverAmount) {
        return coverAmount == 0;
      },
      expandClicked() {
        this.expanded = !this.expanded;
        this.$emit('cardExpanded');
      },
      titleColor(packageObj) {
        switch (packageObj.code) {
          case 'EAC':
            return 'estate-assist-color';
          case 'COC':
            return 'cost-assist-color';
          case 'TAC':
            return 'tax-assist-color';
          case 'CAC':
            return 'cash-assist-color';
          case 'DAC':
            return 'debt-assist-color';
          case 'EC_D':
            return 'education-assist-color';
          default:
            break;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .insurance-card-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .info-section-spacer {
      flex-grow: 1;
    }

    .child-name-section {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;

      h1 {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: #282828;
      }
    }

    .product-with-titles-section {
      display: flex;
      margin-bottom: 16px;

      h1 {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: #282828;
      }
    }

    .extra-product-with-titles-section {
      display: flex;

      h1 {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      }
    }

    .extra-bottom-product-section {
      .horizontal-break {
        margin-top: 20px;
        margin-bottom: 20px;
        border-top: 1px solid #252133;
      }
    }

    .see-more-section {
      display: flex;
      align-items: center;
      cursor: pointer;

      .see-more-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          line-height: 21px;
        }

        .chevron-container {
          height: 24px;
          width: 24px;
        }
      }
    }

    .see-less-section {
      display: flex;
      align-items: center;
      cursor: pointer;

      .see-less-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          line-height: 21px;
        }

        .chevron-container {
          height: 24px;
          width: 24px;
          transform: rotate(180deg);
        }
      }
    }

    .insurance-card-container-section {
      .payout-title {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #282828;
        text-wrap: nowrap;

        .payout-amt {
          font-size: 20px;
          font-weight: 600;
          line-height: 30px;
          text-wrap: nowrap;
        }

        .payout-amt.estate-assist-color {
          color: #ed0080;
        }

        .payout-amt.education-assist-color {
          color: #7395ef;
        }

        .payout-amt.debt-assist-color {
          color: #d65e23;
        }

        .payout-amt.cash-assist-color {
          color: #8aba3e;
        }

        .payout-amt.cost-assist-color {
          color: #e9ab21;
        }

        .payout-amt.tax-assist-color {
          color: #e9ab21;
        }
      }
      .insurance-text {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
      }
      .insurance-text.left {
        padding-right: 8px;
      }
    }

    .insurance-card-container-section {
      display: flex;

      .payout-title {
        .title-icon {
          position: relative;
          display: inline-block;
        }
        .info-icon {
          top: -8px;
          width: 10px;
          height: 10px;
        }
      }
    }

    .info-container {
      margin-bottom: 0px !important;
    }
  }
</style>

<!-- v-if="product.product === 'Tax'" -->
